var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import xss from 'xss';
import { isCSR } from '@raisin/cp-utils';
import apiRoutes from './apiRoutes';
import createClient from './createClient';
const BASE_URL = '/savingglobal/rest/open_api/v2';
export const METHODS = {
    GET: 'get',
    POST: 'post',
};
// similar to Lodash.get, allows us to access object properties by strings
const resolveObjPath = (path, obj) => path.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj);
export const createAsyncAction = (pathKey, method = METHODS.GET, baseUrl = BASE_URL, useJwt = false, config, params, pathParams) => __awaiter(void 0, void 0, void 0, function* () {
    let apiRoute = resolveObjPath(pathKey, apiRoutes.production);
    // TODO: implement a proper mock server for dev env? maybe https://www.npmjs.com/package/nock
    if (process.env.NODE_ENV === 'development' ||
        (isCSR() && window.location.hostname === 'localhost')) {
        const mockFile = resolveObjPath(pathKey, apiRoutes.local);
        if (mockFile) {
            const mockResponse = require(`../__mocks__${mockFile}`);
            // eslint-disable-next-line no-console
            console.debug(`Call for ${pathKey} (${baseUrl}${apiRoute}) was mocked with ${mockFile}.`, {
                response: mockResponse,
            });
            return mockResponse;
        }
        else {
            // eslint-disable-next-line no-console
            console.warn(`Mock file missing for ${pathKey}`);
        }
    }
    const client = createClient(baseUrl, useJwt);
    if (pathParams) {
        Object.entries(pathParams).forEach(([key, value]) => {
            apiRoute = apiRoute.replace(`:${key}`, encodeURIComponent(value));
        });
    }
    switch (method) {
        case METHODS.POST:
            return client.post(apiRoute, params && xss(params));
        case METHODS.GET:
            return client.get(apiRoute, config);
        default:
            throw new Error(`Invalid HTTP method for ${pathKey}: ${method}`);
    }
});
//# sourceMappingURL=index.js.map